<!-- Read-only display of a submitted scale answer as "value / maxValue". -->

<script lang="ts" setup>
import type { ScaleInputConfig, ScaleInputValue } from '@sigma/common/forms/ScaleInput.js';

interface Props {
  /** The scale input configuration with max value info. */
  config: ScaleInputConfig;
  /** The scale answer value to display. */
  value: ScaleInputValue;
}

defineProps<Props>();
</script>

<template>{{ value.value }} / {{ config.maxValue }}</template>
